import styled from 'styled-components';
import { MediaQuery, NeutralColors } from 'theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 802px;
  width: 90%;
  margin: auto;

  .fms-btn-icon {
    display: flex;
    align-items: center;
  }

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    width: 100%;
    padding: 0 16px;
  }
`;

const BoxIcon = styled.div`
  height: 10px;
  display: flex;
  align-items: center;
  padding-left: 8px;

  svg {
    margin-top: -20px;
  }
`;

const Text = styled.p`
  color: ${NeutralColors[70]};
  margin: 16px auto;

  font-family: 'Noto Sans';
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.09px;
  text-align: center;
`;

const VerifyText = styled.span`
  font-style: italic;
  margin-left: 2px;
`;

const WarningText = styled.span`
  text-decoration-line: underline;
`;

export { BoxIcon, Container, Text, VerifyText, WarningText };
